<template>
  <div :class="'md-layout'">
    <div :class="'md-layout-item md-size-100'">
      <md-card>
        <md-card-header :class="'md-card-header-icon md-card-header-danger'">
          <div :class="'card-icon'">
            <md-icon>assignment</md-icon>
          </div>
          <h4 :class="'title'">
            Review report
          </h4>
        </md-card-header>
        <md-card-content>

          <!--Filters-->
          <div :class="'md-layout'">
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-20 md-large-size-20'">
              <md-field md-clearable>
                <label>Review Reference</label>
                <md-select v-model="filter.reference" md-dense>
                  <md-option v-for="(rf, idx) in references" :key="idx" :value="rf.id">
                    {{ rf.reference }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-20 md-large-size-20'">
              <md-field md-clearable>
                <label :class="'title-select'">Reviewer</label>
                <select :class="'custom-select'" placeholder="Reviewer" v-model="filter.rqr_reviewer" md-dense>
                  <option value="">Reviewer</option>
                  <option :value="user.id" v-for="(user, i) in users" :key="i">
                    {{ user.name }}
                  </option>
                </select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-20 md-large-size-20'">
              <md-field md-clearable>
                <label :class="'title-select'">Engagement Leader</label>
                <select :class="'custom-select'" placeholder="Engagement Leader" v-model="filter.engagement_leader" md-dense>
                  <option value="">Engagement Leader</option>
                  <option :value="user.id" v-for="(user, i) in users" :key="i">
                    {{ user.name }}
                  </option>
                </select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-20 md-large-size-20'">
              <md-field md-clearable>
                <label>Fiscal Year</label>
                <md-select placeholder="Fiscal Year" v-model="filter.fiscal_year" md-dense>
                  <md-option :key="idx" :value="year" v-for="(year, idx) in fiscalYears">
                    {{ year }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div :class="'md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-20 md-large-size-20'">
              <md-field md-clearable>
                <label>RQR Type</label>
                <md-select placeholder="RQR Type" v-model="filter.rqr_type" md-dense>
                  <md-option :value="code" :key="code" v-for="(type, code) in rqrTypesMap">
                    {{ type }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <!--Table-->
          <md-table v-model="questionnaries" table-header-color="orange">
            <md-table-row slot="md-table-row" slot-scope="{ item: q }">
              <md-table-cell md-label="Review Reference">{{ q.advisory.reference }}</md-table-cell>
              <md-table-cell md-label="Engagement Leader">{{ q.engagement_leader ? q.engagement_leader.name : 'N/A' }}</md-table-cell>
              <md-table-cell md-label="Reviewer">{{ q.rqr_reviewer ? q.rqr_reviewer.name : 'N/A' }}</md-table-cell>
              <md-table-cell md-label="Fiscal Year">{{ q.advisory.fiscal_year }}</md-table-cell>
              <md-table-cell md-label="RQR Type">{{ q.advisory.rqr_type | rqrType }}</md-table-cell>
              <md-table-cell md-label="Review Code">{{ q.review_code }}</md-table-cell>
              <md-table-cell md-label="Rating" md-numeric>
                <div v-if="q.advisory.rqr_type === rqrTypeEnum.COMPLICE">
                  <span :class="['status-rating', getRatingClass(q.ratings, 'ecr_client_acceptance', q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">ECR - Client Acceptance</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'independence', q.qnst, q.status, true )]">
                    <md-tooltip md-direction="top">Independence</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'engagement_acceptance', q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">Engagement Acceptance</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'higher_risk_engagements', q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">Higher Risk Engagements</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'contracting', q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">Contracting</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'deliverables_and_disclaimers', q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">Deliverables and Disclaimers</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'documentation' , q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">Documentation</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'performance_and_review' , q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">Performance and Review</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'final' , q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">Overall</md-tooltip>
                  </span>
                </div>
                <div v-if="q.advisory.rqr_type === rqrTypeEnum.QUALITY">
                  <span :class="['status-rating', getRatingClass(q.ratings, 'clear_scope', q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">Clear scope</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'engaged_stakeholders', q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">Engaged stakeholders</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'governance_enabled', q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">Governance enabled decision making</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'focused_benefits_management', q.qnst, q.status, true)] ">
                    <md-tooltip md-direction="top">Focused benefits management</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'managed_risks', q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">Managed risk and opportunities</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'smart_financing', q.qnst, q.status, true)] ">
                    <md-tooltip md-direction="top">Smart financing</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'delivery_enabling_plans', q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">Delivery-enabling plans</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'active_quality', q.qnst, q.status, true)]">
                    <md-tooltip md-direction="top">Active quality management</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'agile_change_control', q.qnst, q.status, true)] ">
                    <md-tooltip md-direction="top">Agile change control</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'integrated_suppliers', q.qnst, q.status, true)] ">
                    <md-tooltip md-direction="top">Integrated suppliers</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings,  'high_performing_teams', q.qnst, q.status, true)] ">
                    <md-tooltip md-direction="top">High performing teams</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'embedded_lifecycle', q.qnst, q.status, true)] ">
                    <md-tooltip md-direction="top">Embedded lifecycle</md-tooltip>
                  </span>
                  <span :class="['status-rating', getRatingClass(q.ratings, 'final', q.qnst, q.status, true)] ">
                    <md-tooltip md-direction="top">Overall</md-tooltip>
                  </span>
                </div>
              </md-table-cell>
              <md-table-cell md-label="Actions" md-numeric>
                <md-button :class="'md-simple md-just-icon'" :md-ripple="false" @click.prevent="
                  $router.push({
                    name: 'Review Report',
                    params: { id: q.id },
                  })
                  " title="Analyze">
                  <md-icon>bar_chart</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <md-empty-state md-icon="list" md-label="Questionnaries report" md-description="No questionnaries found"
            v-if="!isFetching && questionnaries.length === 0">
          </md-empty-state>
          <div :class="'md-flex text-center'" v-if="questionnaries.length > 0">
            <Pagination :total="pagination.totalItems" :value="pagination.currentPage" :perPage="pagination.perPage"
              @input="changePage" />
          </div>
          <div :class="'md-flex text-center'" v-if="isFetching">
            <md-progress-spinner :class="'md-accent'" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { reviewStatus, rqrType } from "@/filters";
import { rqrTypesMap } from "@/filters/rqrType";
import { Pagination } from "@/components";
import { camelToSnake } from "@/methods/api/requests";
import * as utils from "@/utils";
import * as filters from "@/filters";
import rqrTypeEnum from "@/enums/rqrType"

export default {
  created() {
    if (!this.canViewReport) {
      this.$router.push({ name: "Reviews" });
      this.$toast.show(
        "Only admins, reviewers and RQR leaders can access reports"
      );
      return;
    }
    this.filter["engagement_leader"] = this.$store.state["reviewslistingFilters"]["engagement_leader"];
    this.filter["rqr_reviewer"] = this.$store.state["reviewslistingFilters"]["rqr_reviewer"];
    this.filter["fiscal_year"] = this.$store.state["reviewslistingFilters"]["fiscal_year"];
    this.filter["rqr_type"] = this.$store.state["reviewslistingFilters"]["rqr_type"];
    this.filter["reference"] = this.$store.state["reviewslistingFilters"]["reference"];

    // Inicializar currentPage com base no parâmetro da rota
    this.pagination.currentPage = parseInt(this.$route.params["id"]) || 1;

    this.getReviews();
    this.getUsers();
    this.getReferences();
  },

  data() {
    return {
      references: [],
      questionnaries: [],
      users: [],
      isFetching: false,
      isTryingToDelete: false,
      deletableReview: {},
      isDeletingReview: false,
      filter: {
        engagement_leader: "",
        rqr_reviewer: "",
        fiscal_year: "",
        rqr_type: "",
        reference: "",
        /* Fixed status for only finished reviews
          status: 5,
          */
      },
      pagination: {
        totalItems: "",
        currentPage: "",
        perPage: "",
      },
      rqrTypesMap,
      rqrTypeEnum,
    };
  },

  components: {
    Pagination,
  },

  computed: {
    canViewReport() {
      return this.isAdmin || this.isReviewer || this.isRQRLeader ||
        this.isAdminTI || this.isAudit ? true : false;
    },

    currentProfile() {
      return this.$store.state.currentProfile;
    },

    draftResultsOnly() {
      return this.currentProfile === "reviewer" || this.currentProfile === "rqr_leader" ? true : false;
    },

    fiscalYears() {
      return utils.getFiscalYears();
    },

    filtersQuery() {
      return filters.getFiltersQuery(this.filter);
    },

    getRatingClass() {
      return (ratings, section, qnst, status, showError) => {
        //console.log("Params recebidos para getRatingClass:", { ratings, section, qnst, status, showError });
        let rating = "empty";
        //console.log("Initial rating:", rating);

        if (ratings && Array.isArray(ratings)) {
          ratings.forEach((rat) => {
            if (rat.section === section) {
              switch (rat.rating) {
                case 1:
                  rating = "good";
                  break;
                case 2:
                  rating = "medium";
                  break;
                case 3:
                  rating = "bad";
                  break;
                default:
                  break;
              }
            }
          });
        }

        if (qnst && qnst.questions) {
          const unansweredQuestions = qnst.questions.filter((q) =>
            status == 6 &&
            (q.section_text === "Engagement Leader" || q.section_text === "Manager")
              ? false : q.answered === false
          );

          if (unansweredQuestions.length > 0 && showError)
            rating = rating.concat(" answer-to-apply");
        }
        return rating;
      };
    },

    isAdmin() {
      return this.$store.getters.isAdmin;
    },

    isAdminTI() {
      return this.$store.state.currentProfile === "adminTi" ? true : false;
    },

    isAudit() {
      return this.$store.state.currentProfile === "audit" ? true : false;
    },

    isReviewer() {
      return this.$store.state.currentProfile === "reviewer" ? true : false;
    },

    isRQRLeader() {
      return this.$store.state.currentProfile === "rqr_leader" ? true : false;
    },

    paginationQuery() {
      return utils.getPaginationQuery(this.pagination.currentPage);
    },

    profileQuery() {
      return `profile=${this.currentProfile}&`;
    },
  },

  filters: {
    reviewStatus,
    rqrType,
  },

  methods: {
    changePage(toPage) {
      if (toPage === this.pagination.currentPage)
        return;

      this.pagination.currentPage = toPage;
      this.$router.push({ name: "Reports List", params: { id: toPage } });
      this.getReviews();
    },

    getReferences() {
      this.$api.request("all/advisories").then((response) => {
        this.references = camelToSnake(response.data);
          // .sort((a, b) => a.reference.localeCompare(b.reference));
      });
    },

    getReviews() {
      this.isFetching = true;
      const draftResultsQuery = this.draftResultsOnly === true ? "draft" : "";
      const page = this.pagination.currentPage || this.$route.params["id"] || 1;
      this.$api
        .request(
          `reviews?${this.filtersQuery}page=${page}&${this.profileQuery}status=${draftResultsQuery}`
        )
        .then((response) => {
          this.questionnaries = camelToSnake(response.data.data);
          this.pagination.totalItems = response.data.meta.total;
          this.pagination.currentPage = response.data.meta.currentPage;
          this.pagination.perPage = response.data.meta.perPage;
        })
        .finally(() => {
          this.isFetching = false;
        });
    },

    getUsers() {
      this.isFetching = true;
      this.$api
        .request("all/users")
        .then((response) => {
          this.users = camelToSnake(response.data)
            .filter((d) => d.inactive_user === null)
            // .sort((a, b) => a.name.localeCompare(b.name));
        })
        .finally(() => {
          this.isFetching = false;
        });
    },

    printReport() {
      window.print();
    },
  },

  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },

  watch: {
    filter: {
      handler: function () {
        this.$store.commit("REVIEWSLISTINGFILTERS", this.filter);

        this.getReviews();
      },
      deep: true,
    },

    currentProfile: function () {
      this.getReviews();
    },

    "$store.state.currentProfile"() {
      if (!this.canViewReport) {
        this.$router.push({ name: "Reviews" });

        this.$toast.show(
          "Only admins, reviewers and RQR leaders can access reports"
        );

        return;
      }
    },
  },

  //Not utilized
    // async exportXlsx() {
    //   this.$api.request
    //     .get(`report/export-excel`, {
    //       headers: {
    //         "Content-Type":
    //           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //         "Access-Control-Allow-Origin": "*",
    //         "Access-Control-Allow-Headers": "Content-Type",
    //       },
    //       responseType: "arraybuffer",
    //     })
    //     .then((response) => {
    //       const url = URL.createObjectURL(
    //         new Blob([response.data], {
    //           type: "application/vnd.ms-excel",
    //         })
    //       );
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", "report.xlsx");
    //       document.body.appendChild(link);
    //       link.click();
    //     })
    //     .catch(async (err) => {
    //       const errJson = await new Promise((resolve) => {
    //         const reader = new FileReader();
    //         reader.onloadend = (e) => {
    //           resolve(JSON.parse(e.target.result));
    //         };
    //         reader.readAsText(err.response.data);
    //       });
    //       return errJson;
    //     });
    // },
};
</script>
